export function formatDateTime(timestamp: string) {
  if (!timestamp) return '';

  const date = new Date(timestamp);

  const formattedDate = date.toLocaleDateString('hu-HU');
  const formattedTime = date.toLocaleTimeString('hu-HU', {
    hour: '2-digit',
    minute: '2-digit',
  });

  return `${formattedDate} ${formattedTime}`;
}

// a local time as the backend takes it: HH:mm, also from a time picker giving HH:mm:ss
export function toHourMinute(localTime?: string | null): string | undefined {
  return localTime?.slice(0, 5);
}

export function getMinutesDifference(date1: Date, date2: Date): number {
  const diffMs = Math.abs(date1.getTime() - date2.getTime());
  return Math.floor(diffMs / 60000);
}
